/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ChatBubble/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ChatBubble({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ChatBubble",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ChatBubble.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-hlJAj': alignSelf,'--mt-2-hlJAj': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-hlJAj': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-hlJAj': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-hlJAj': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-hlJAj': opacity,'--w-10-hlJAj': typeof width === 'number' ? `${width}px` : width,'--h-11-hlJAj': typeof height === 'number' ? `${height}px` : height,'--f-12-hlJAj': fill,'--a-7-hlJAj': isAnimated ? animation : "none",'--sd-8-hlJAj': isAnimated ? strokeDashoffset : 0,'--sd-9-hlJAj': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2ChatBubble.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M10.04.694a7 7 0 00-9.009 9.963l-1 2.663a.503.503 0 00.56.672l3.49-.63A7 7 0 0010.04.693zM3.37 5.395A.63.63 0 014 4.766h5.997a.63.63 0 010 1.258H4a.63.63 0 01-.63-.629zM4 7.975a.63.63 0 000 1.259h3.998a.63.63 0 100-1.259H4z"
 style={{'--f-12-hlJAj': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}